<div class="container-div">
  <div class="headingDiv d-flex justify-content-between">
    <span class="headingText">Dikshyarthi Details</span>
    <div class="img-div" mat-dialog-close>
      <img
        src="../../../../../assets/images/crossIconDarkTheme.svg"
        style="width: 0.65rem"
      />
    </div>
  </div>
  @if(!stepOneDone){
  <form [formGroup]="initiationDetails">
    <div class="initiation-div">
      <p class="sub-text">Personal Details</p>
      <div class="details d-flex flex-column">
        <div class="initiation-details d-flex">
          <div class="input-content">
            <span class="input-text">First Name *</span>
            <input
              type="text"
              formControlName="firstName"
              placeholder="Enter first name"
              class="input-div dp-input-control"
              (keydown)="restrictNameInput($event)"
            />
            @if( stepOne && initiationDetails.get('firstName')?.invalid){
            <span class="error-text">Enter First Name</span>
            }
          </div>
          <div class="input-content">
            <span class="input-text">Middle Name</span>
            <input
              type="text"
              formControlName="middleName"
              placeholder="Enter middle name"
              class="dp-input-control input-div"
            />
          </div>
          <div class="input-content">
            <span class="input-text">Last Name *</span>
            <input
              type="text"
              formControlName="lastName"
              placeholder="Enter last name"
              class="dp-input-control input-div"
              [matAutocomplete]="auto"
            />
            @if(stepOne && !selectedLastName){
            <span class="error-text">Select Last Name from Dropdown</span>
            }

            <mat-autocomplete #auto="matAutocomplete">
              @for (item of surnameList ; track item) {
              <mat-option
                (click)="onLastNameDropDown(item, 'ln')"
                [value]="item"
                >{{ item }}</mat-option
              >
              }
            </mat-autocomplete>
          </div>
        </div>
        <div class="initiation-details d-flex">
          <div class="input-content">
            <span class="input-text">Ritwik's Name</span>

            <input
              type="text"
              formControlName="ritwikName"
              placeholder="Enter ritwik's name"
              class="dp-input-control input-div"
              [matAutocomplete]="auto1"
            />
            <mat-autocomplete #auto1="matAutocomplete">
              @for (item of ritwikList ; track item) {
              <mat-option
                (click)="onRitwikDropDown(item)"
                [value]="item.dwd_worker_name"
                >{{ item.dwd_worker_name }}</mat-option
              >
              }
            </mat-autocomplete>
            @if(stepOne && !selectedRitwik){
            <span class="error-text">Select Ritwik from Dropdown</span>
            }
          </div>
          <div class="input-content">
            <span class="input-text">Contact *</span>
            <input
              type="tel"
              formControlName="contactNo"
              placeholder="Enter Contact No"
              class="dp-input-control input-div"
              maxlength="10"
              minlength="10"
              (keydown)="restrictNumberInput($event)"
            />
            @if(stepOne && initiationDetails.get('contactNo')?.value.length<10
            && firstDigit<6) {
            <span class="error-text">Please enter valid phone number</span>
            }
          </div>
        </div>

        <div class="initiation-details d-flex">
          <div class="input-content">
            <span class="input-text">Guardian's First Name*</span>
            <input
              type="text"
              formControlName="guardianFname"
              placeholder="Enter guardian's first name"
              class="dp-input-control input-div"
              (keydown)="restrictNameInput($event)"
            />
            @if(stepOne && initiationDetails.get('guardianFname')?.invalid ){
            <span class="error-text">Enter guardian's first name</span>
            }
          </div>
          <div class="input-content">
            <span class="input-text">Guardian's Middle Name</span>
            <input
              type="text"
              formControlName="guardianMname"
              placeholder="Enter guardian's middle name"
              class="dp-input-control input-div"
            />
          </div>
          <div class="input-content">
            <span class="input-text">Guardian's Last Name *</span>
            <input
              type="text"
              formControlName="guardianLname"
              placeholder="Enter guardian's last name"
              class="dp-input-control input-div"
              [matAutocomplete]="autogl"
            />
            @if(stepOne && !selectedGuardianLastName ){
            <span class="error-text">Select last name from dropdown</span>
            }
            <mat-autocomplete autoActiveFirstOption #autogl="matAutocomplete">
              @for (item of surnameList ; track item) {
              <mat-option
                (click)="onLastNameDropDown(item, 'gln')"
                [value]="item"
              >
                {{ item }}</mat-option
              >
              }
            </mat-autocomplete>
          </div>
        </div>
        <div class="initiation-details d-flex">
          <div class="input-content">
            <span class="input-text">Qualification *</span>
            <input
              type="text"
              formControlName="qualification"
              placeholder="Enter qualification"
              class="dp-input-control input-div"
            />
            @if(stepOne && initiationDetails.get('qualification')?.invalid ) {
            <span class="error-text">Please enter qualification</span>
            }
          </div>
          <div class="input-content">
            <span class="input-text">Occupation *</span>
            <input
              type="text"
              formControlName="occupation"
              placeholder="Enter occupation"
              class="dp-input-control input-div"
            />
            @if(stepOne && initiationDetails.get('occupation')?.invalid ) {
            <span class="error-text">Please enter occupation</span>
            }
          </div>
          <div class="input-content">
            <span class="input-text">Age *</span>
            <input
              type="tel"
              formControlName="age"
              placeholder="Enter your age"
              class="dp-input-control input-div"
              (keydown)="restrictNumberInput($event)"
              maxlength="2"
            />
            @if(stepOne && initiationDetails.get('age')?.invalid ) {
            <span class="error-text">Please enter age</span>
            }
          </div>
        </div>
        <div class="initiation-details d-flex">
          <div class="input-content">
            <span class="input-text">Race *</span>
            <input
              type="text"
              formControlName="race"
              placeholder="Enter race"
              class="dp-input-control input-div"
            />
            @if(stepOne && initiationDetails.get('race')?.invalid ) {
            <span class="error-text">Please enter race</span>
            }
          </div>
          <div class="input-content">
            <span class="input-text">Varna *</span>
            <input
              type="text"
              formControlName="varna"
              placeholder="Enter varna"
              class="dp-input-control input-div"
            />
            @if(stepOne && initiationDetails.get('varna')?.invalid ) {
            <span class="error-text">Please enter varna</span>
            }
          </div>
          <div class="input-content">
            <span class="input-text">No of Initiated Member*</span>
            <input
              type="tel"
              formControlName="initiatedMember"
              placeholder="Enter no of initiated family member"
              class="dp-input-control input-div"
              (keydown)="restrictNumberInput($event)"
              maxlength="2"
            />
            @if(stepOne && initiationDetails.get('initiatedMember')?.invalid ) {
            <span class="error-text">Please enter initiatedMember</span>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="initiation-div">
      <p class="sub-text">Present Address</p>
      <div class="details d-flex flex-column">
        <div class="initiation-details d-flex">
          <div class="initiation-input">
            <span class="input-text">Address *</span>
            <input
              type="text"
              formControlName="presAddress"
              placeholder="Enter address"
              (keydown)="restrictAddressInput($event)"
              class="input-div dp-input-control"
            />
            @if(stepOne && initiationDetails.get('presAddress')?.invalid ){
            <span class="error-text">Enter address</span>
            }
          </div>
        </div>
        <div class="initiation-details d-flex addMobver">
          <div class="initiation-input">
            <span class="input-text">Pincode *</span>
            <input
              type="tel"
              formControlName="presPincode"
              placeholder="Enter pincode"
              class="input-div dp-input-control"
              (keydown)="restrictNumberInput($event)"
              maxlength="6"
            />
            @if(stepOne && initiationDetails.get('presPincode')?.invalid ){
            <span class="error-text">Enter Pincode</span>
            }
          </div>
          <div class="initiation-input">
            <span class="input-text">District</span>
            @if(presDistArr.length<=1){
            <input
              type="text"
              placeholder="Enter PIN first"
              formControlName="presDistrict"
              class="input-div dp-input-control"
              readonly
            />
            } @else{

            <mat-form-field class="select-mat-form-field">
              <mat-select
                formControlName="presDistrict"
                class="custom-mat-select"
                placeholder="Select from dropdown"
              >
                @for(item of presDistArr;track item){
                <mat-option
                  (click)="onSelectDropDown(item, 'presDistrict')"
                  [value]="item"
                  >{{ item }}</mat-option
                >}
              </mat-select>
            </mat-form-field>
            }
          </div>
          <div class="initiation-input">
            <span class="input-text">State</span>

            <input
              type="text"
              formControlName="presState"
              placeholder="Enter PIN first"
              class="input-div dp-input-control"
              readonly
            />
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <div class="initiation-div">
      <div class="perm-address-heading d-flex justify-content-between">
        <span class="sub-text">Permanent Address</span>
        <div class="add-checkbox d-flex">
          <label class="custom-checkbox">
            <input
              type="checkbox"
              (change)="onCheckboxChange($event)"
              formControlName="checkBox"
            />
            <span class="checkmark"></span>
          </label>

          <span class="sub-text">Same as present address</span>
        </div>
      </div>
      <div class="details d-flex flex-column">
        <div class="initiation-details d-flex addMobver">
          <div class="initiation-input">
            <span class="input-text">Address *</span>
            <input
              type="text"
              [readonly]="checkBoxClick"
              formControlName="permAddress"
              placeholder="Enter address"
              (keydown)="restrictAddressInput($event)"
              class="input-div dp-input-control"
            />
            @if(stepOne && initiationDetails.get('permAddress')?.invalid ){
            <span class="error-text">Enter address</span>
            }
          </div>
        </div>
        <div class="initiation-details d-flex addMobver">
          <div class="initiation-input">
            <span class="input-text">Pincode *</span>
            <input
              type="tel"
              [readonly]="checkBoxClick"
              formControlName="permPincode"
              placeholder="Enter pincode"
              class="input-div dp-input-control"
              (keydown)="restrictNumberInput($event)"
              maxlength="6"
            />
            @if(stepOne && initiationDetails.get('permPincode')?.invalid ){
            <span class="error-text">Enter Pincode</span>
            }
          </div>
          <div class="initiation-input">
            <span class="input-text">District</span>
            <!-- @if(permDistArr.length<=1){ -->
            @if(permDistArr.length<=1){
            <input
              type="text"
              placeholder="Enter PIN first"
              formControlName="permDistrict"
              class="input-div dp-input-control"
              readonly
            />
            } @else if(!checkBoxClick && permDistArr.length>1){
            <mat-form-field class="select-mat-form-field">
              <mat-select
                formControlName="permDistrict"
                class="custom-mat-select"
                placeholder="Select from dropdown"
              >
                @for(item of permDistArr;track item){
                <mat-option
                  (click)="onSelectDropDown(item, 'permDistrict')"
                  [value]="item"
                  >{{ item }}</mat-option
                >}
              </mat-select>
            </mat-form-field>
            }
          </div>
          <div class="initiation-input">
            <span class="input-text">State</span>

            <input
              type="text"
              formControlName="permState"
              placeholder="Enter PIN first"
              class="input-div dp-input-control"
              readonly
            />
          </div>
        </div>
      </div>
    </div>
    <div class="initiation-div">
      <p class="sub-text">Date Details</p>
      <div class="details d-flex flex-row">
        <div class="input-content">
          <span class="input-text">Initiation Date *</span>
          <input
            type="date"
            class="dp-input-control input-div"
            placeholder="YYYY-MM-DD"
            formControlName="initiationDate"
            [max]="maxDate"
          />
          @if(stepOne && initiationDetails.get('initiationDate')?.invalid ){
          <span class="error-text">Enter date of birth</span>
          }
        </div>

        <div class="input-content">
          <span class="input-text">Initiation Place *</span>
          <input
            type="text"
            class="dp-input-control input-div"
            placeholder="Enter initiation place"
            formControlName="initiationPlace"
          />
          @if(stepOne && initiationDetails.get('initiationPlace')?.invalid ){
          <span class="error-text">Enter initiation place</span>
          }
        </div>
      </div>
    </div>
  </form>
  } @else{
  <div class="initiation-div">
    <p class="sub-text">Upload photos</p>
    <div class="details d-flex flex-row">
      <div class="img-content">
        <span class="input-text">Diksha Patra Front Page *</span>
        <div class="uploadLabel">
          <input
            fileInput
            type="file"
            accept="image/jpeg, image/png"
            (change)="photos($event, 'f')"
            maxlength="1"
            id="front-img"
            hidden
          />
          <label for="front-img" class="dp-primary-btn upload-text"
            >Upload&nbsp;Photos</label
          >
        </div>
        <div>
          <span class="file-text">{{ returnFilesArr[0].name }}</span>
        </div>
        <!-- @if(returnFilesArr[0]===[]){
        <span class="error-text">Enter Front Image</span>
        } -->
      </div>
      <div class="img-content">
        <span class="input-text">Diksha Patra Back Page *</span>
        <div class="uploadLabel">
          <input
            fileInput
            type="file"
            accept="image/jpeg, image/png"
            (change)="photos($event, 'b')"
            maxlength="1"
            id="back-img"
            hidden
          />
          <label for="back-img" class="dp-primary-btn upload-text"
            >Upload&nbsp;Photos</label
          >
        </div>
        <div>
          <span class="file-text">{{ returnFilesArr[1].name }}</span>
        </div>
        <!-- @if(returnFilesArr[1].length===0){
        <span class="error-text">Enter Back Image</span>
        } -->
      </div>
    </div>
  </div>

  }
  <div class="btn-div d-flex justify-content-between flex-row">
    @if(stepOneDone){
    <button class="dp-secondary-btn btn-name" (click)="onPreviousClick()">
      Previous
    </button>
    <button class="dp-primary-btn btn-name" (click)="onSubmit()">Submit</button
    >}@else{
    <button class="dp-primary-btn btn-name" (click)="onNextClick()">Next</button
    >}
  </div>
</div>
<app-loader [isLoading]="isLoading"></app-loader>
